import Component from '@glimmer/component';
import { task, timeout } from 'ember-concurrency';

export default class DeluxePlayerScheduleDayComponent extends Component {

  triggerLoadTask = task({restartable: true, maxConcurrency: 1}, async reload => {
    // console.log('waiting for load timeout', this.args.date)
    await timeout(200);
    // console.log('triggering on load', this.args.date)
    this.args.onLoad(reload)
  });
}
